import { BlockProps, IBlockLocation } from '../../content-blocks/type';
import { GmailBlockProps } from './type';

interface Props {
  key: string;
  label: string;
  location: IBlockLocation;
}

export const createGmailBlock = (props: Props): GmailBlockProps => {
  return {
    type: 'gmail',
    value: props.label,
    width: 20,
    height: 20,
    isVisible: false,
    x: 0,
    y: 0,
    fontSize: 12,
    isBold: false,
    isItalics: false,
    isCapsLocks: false,
    ...props,
  };
};

export function isGmailBlock(block: BlockProps): block is GmailBlockProps {
  return block.type === 'gmail';
}
